/**
 * I cinque ruoli, in un file loro.
 *
 * Non è una separazione per il gusto di separare: `index.ts` (i corpi in
 * ingresso) e `risposte.ts` (le letture) hanno **entrambi** bisogno di questa
 * enumerazione, e farla stare in uno dei due vorrebbe dire un anello di import
 * fra i due file — di quelli che a runtime tengono per un pelo, finché qualcuno
 * non legge il valore durante l'inizializzazione di un modulo e si trova
 * `undefined` senza capire perché.
 *
 * La stessa lista sta in `packages/domain/src/permessi.ts` come `RUOLI`, e non
 * è una svista: là è **la decisione** — quale ruolo può fare cosa — qui è la
 * **forma del dato che attraversa il confine**, e `shared` non può dipendere dal
 * dominio, perché finisce nel bundle del browser. Le due sono tenute in riga da
 * un'asserzione di tipo in `apps/api/src/comune/contratti.ts`: se una delle due
 * cambia da sola, l'API non compila.
 */
import { z } from 'zod';
export const zRuolo = z.enum([
    'ricezione',
    'produzione',
    'magazzino',
    'fine-linea',
    'amministratore',
]);
//# sourceMappingURL=roles.js.map